export default __webpack_public_path__ + "static/media/writeng.da28e465.png";